"use client";
import I from "../../hooks/useHandleStateClick.js";
import { cn as v } from "../../utils/cn.js";
import { dataBooleanAttr as c } from "../../utils/dataBooleanAttr.js";
import { setComponentColor as L } from "../../utils/setComponentColor.js";
import { colorVariants as M } from "../../vars/variants.js";
import { useMemo as s, useCallback as V } from "react";
import { stylesBadge as t } from "./styles.js";
function R(w) {
  const {
    ref: g,
    as: z,
    children: D,
    className: _,
    content: i,
    disableOutline: j,
    color: n = "primary",
    variant: m = "solid",
    size: l = "md",
    wide: b,
    shape: h = "rectangle",
    placement: C = "top-right",
    hideOutline: f,
    isInvisible: d,
    isOneChar: u,
    isPing: O,
    loading: a,
    disabled: r,
    onClick: p,
    classNames: e,
    ...k
  } = w, y = I(p, a, r), x = z || "span", B = s(
    () => {
      var o;
      return ((o = String(i)) == null ? void 0 : o.length) === 1 || u;
    },
    [u, i]
  ), P = s(
    () => {
      var o;
      return !i || ((o = String(i)) == null ? void 0 : o.length) === 0;
    },
    [i]
  ), A = s(
    () => v(t.base, b && t.wide, e == null ? void 0 : e.base),
    [e == null ? void 0 : e.base, b]
  ), S = s(
    () => v(
      t.badge,
      t.size[l],
      M[m][n],
      t.placement[C],
      P && t.isDot[l],
      B && t.isOneChar,
      O && t.isPing,
      !f && t.showOutline,
      p && t.onClick,
      e == null ? void 0 : e.badge
    ),
    [
      l,
      m,
      n,
      C,
      P,
      B,
      O,
      f,
      p,
      e == null ? void 0 : e.badge
    ]
  ), H = V(
    (o = {}) => ({
      "data-loading": c(a),
      "data-disabled": c(r),
      "data-invisible": c(d),
      "data-shape": h,
      ...k,
      ref: g,
      className: S,
      style: L(n),
      onClick: y,
      disabled: r || a
    }),
    [
      S,
      n,
      r,
      y,
      d,
      a,
      k,
      g,
      h
    ]
  );
  return {
    Component: x,
    children: D,
    content: i,
    baseStyles: A,
    isInvisible: d,
    getBadgeProps: H
  };
}
export {
  R as useBadge
};
